import { formatStringDate } from '@/helpers/formatStringDate';
import { useAppDispatch, useAppSelector } from '@/hooks';
import {
  Center,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  VStack,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { DocumentIdForm } from './DocumentIdForm';
import { getDocumentsIds } from './actions';
import { selectDocumentsIds } from './reducer';

export const DocumentsIdsView: React.FC = () => {
  const documentsIds = useAppSelector(selectDocumentsIds);
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(getDocumentsIds())
      .unwrap()
      .then(() => setIsLoading(false))
      .catch((err) => {
        console.error('Error retrieving data:', err);
      });
  }, []);

  if (isLoading)
    return (
      <Center mt={5}>
        <Spinner size="xl" />
      </Center>
    );

  return (
    <VStack gap={10} mt={5}>
      <TableContainer>
        <Table>
          <Thead>
            <Tr>
              <Th>Document</Th>
              <Th isNumeric>Document ID</Th>
              <Th>Updated At</Th>
              <Th>Enabled</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {documentsIds &&
              documentsIds.map((docIdData) => {
                return (
                  <Tr key={docIdData.id}>
                    <Td>{docIdData.displayName}</Td>
                    <Td isNumeric>{docIdData.docId === -1 ? 'Relevance' : docIdData.docId}</Td>
                    <Td>{formatStringDate(docIdData.updatedAt, true)}</Td>
                    <Td>{docIdData.enabled.toString().toUpperCase()}</Td>
                    <Td>
                      <DocumentIdForm docIdData={docIdData} />
                    </Td>
                  </Tr>
                );
              })}
          </Tbody>
        </Table>
      </TableContainer>
    </VStack>
  );
};
